import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import axios from "axios";
import { Button, Classes, Icon, Menu, Popover, Position } from "@blueprintjs/core";
import Dropzone from "react-dropzone"; // import { first } from "lodash";

import classnames from "classnames";
import { some, forEach, map, every, compact, findIndex, merge } from "lodash";
import shortid from "shortid";
import ItemUpload from "./itemUpload";

function noop() {} // wink wink


var emptyPromise = Promise.resolve.bind(Promise);

var Uploader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Uploader, _Component);

  function Uploader(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "showProgress", function (progressEvent, fileId) {
      if (progressEvent) {
        var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
        var up = _this.state.uploading;
        up[fileId] = merge(up[fileId], {
          percentage: percentCompleted,
          loading: true,
          saved: false,
          error: null
        });

        _this.setState({
          uploading: up
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFinishUpload", function (saved, fileId) {
      var up = _this.state.uploading;
      up[fileId] = merge(up[fileId], {
        percentage: 100,
        loading: false,
        saved: true,
        error: null,
        info: saved,
        path: saved.publicUrl
      });
      _this.props.fileFinished && _this.props.fileFinished(saved, fileId);

      _this.checkLoadings(up);
    });

    _defineProperty(_assertThisInitialized(_this), "onUploadError", function (e, fileId) {
      var up = _this.state.uploading;
      up[fileId] = merge(up[fileId], {
        percentage: 0,
        loading: false,
        saved: false,
        error: JSON.stringify(e)
      });

      _this.checkLoadings(up);
    });

    _defineProperty(_assertThisInitialized(_this), "abortUpload", function (item) {
      _this.uploadingFiles[item.id].abortUpload();

      var up = _this.state.uploading;
      up[item.id] = {
        percentage: 0,
        loading: false,
        saved: false,
        error: "Upload aborted"
      };

      _this.checkLoadings(up);
    });

    _defineProperty(_assertThisInitialized(_this), "abortAllUploads", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return forEach(_this.uploadingFiles, function (item) {
                return item.abortUpload();
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "checkLoadings", function (items) {
      var m = map(items, function (item) {
        return item;
      });
      var l = some(m, {
        loading: true
      });
      var s = every(m, {
        saved: true
      });
      if (s || !l) _this.props.onFieldSubmit(Object.values(items));

      _this.setState({
        uploading: items,
        loading: l,
        allSaved: s
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteItem", function (item) {
      var fields = _this.props.fileList;

      if (!fields) {
        console.error("Can't delete item");
        return;
      }

      var i = findIndex(fields, {
        id: item.id
      });
      delete fields[i]; //we need to compact array to avoid empty fields

      var compactFields = compact(fields);

      _this.props.onChange(compactFields);
    });

    _defineProperty(_assertThisInitialized(_this), "itemListRender", function (item) {
      var isActive = false;
      var value = 0;
      var error = null;
      var saved = false;
      var fileUpload = _this.state.uploading[item.id];

      if (fileUpload) {
        isActive = fileUpload.loading;
        value = fileUpload.percentage;
        error = fileUpload.error;
        saved = fileUpload.saved;
      }

      return /*#__PURE__*/React.createElement(ItemUpload, {
        key: item.id,
        item: item,
        active: isActive,
        value: value,
        error: error,
        saved: saved,
        onClick: function onClick(file) {
          console.info("Try download file");
          console.info(file);
        },
        onCancel: isActive ? _this.abortUpload.bind(_assertThisInitialized(_this), item) : _this.deleteItem.bind(_assertThisInitialized(_this), item)
      });
    });

    _this.uploadingFiles = {};
    _this.state = {
      loading: false,
      uploading: {},
      uploadingFiles: {},
      allSaved: false,
      onDragOver: false,
      startUploads: false,
      startUpload: false,
      abortUploads: false,
      fileSetId: null
    };
    return _this;
  }
  /* componentDidUpdate(prevProps) {
    if (prevProps.startUpload !== this.props.startUpload) {
      if (this.props.startUpload) {
        this.sendFiles();
      }
    }
     if (this.props.updateStatus) {
      this.props.updateStatus(this.props.fieldName, {
        loading: this.state.loading,
        allSaved: this.state.allSaved
      });
    }
     if (this.props.abortUploads) {
      this.abortAllUploads();
    }
  } */


  var _proto = Uploader.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        loading = _this$state.loading,
        uploading = _this$state.uploading;
    var _this$props = this.props,
        accept = _this$props.accept,
        maybeContentOverride = _this$props.contentOverride,
        innerIcon = _this$props.innerIcon,
        innerText = _this$props.innerText,
        action = _this$props.action,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? "" : _this$props$className,
        minimal = _this$props.minimal,
        fileLimit = _this$props.fileLimit,
        readBeforeUpload = _this$props.readBeforeUpload,
        uploadInBulk = _this$props.uploadInBulk,
        _this$props$showUploa = _this$props.showUploadList,
        showUploadList = _this$props$showUploa === void 0 ? true : _this$props$showUploa,
        beforeUpload = _this$props.beforeUpload,
        fileList = _this$props.fileList,
        fileListItemRenderer = _this$props.fileListItemRenderer,
        _this$props$onFileSuc = _this$props.onFileSuccess,
        onFileSuccess = _this$props$onFileSuc === void 0 ? emptyPromise : _this$props$onFileSuc,
        _this$props$onFieldSu = _this$props.onFieldSubmit,
        onFieldSubmit = _this$props$onFieldSu === void 0 ? noop : _this$props$onFieldSu,
        _this$props$onRemove = _this$props.onRemove,
        onRemove = _this$props$onRemove === void 0 ? noop : _this$props$onRemove,
        _this$props$onChange = _this$props.onChange,
        onChange = _this$props$onChange === void 0 ? noop : _this$props$onChange,
        onFileClick = _this$props.onFileClick,
        _this$props$dropzoneP = _this$props.dropzoneProps,
        dropzoneProps = _this$props$dropzoneP === void 0 ? {} : _this$props$dropzoneP,
        overflowList = _this$props.overflowList,
        disabled = _this$props.disabled,
        showFilesCount = _this$props.showFilesCount,
        threeDotMenuItems = _this$props.threeDotMenuItems,
        onPreviewClick = _this$props.onPreviewClick,
        _this$props$axiosInst = _this$props.axiosInstance,
        axiosInstance = _this$props$axiosInst === void 0 ? window.api || axios : _this$props$axiosInst;
    var contentOverride = maybeContentOverride;

    if (contentOverride && typeof contentOverride === "function") {
      contentOverride = contentOverride({
        uploading: uploading,
        loading: loading
      });
    }

    var self = this;
    var acceptToUse = Array.isArray(accept) ? accept.join(", ") : accept;
    var fileListToUse = fileList ? fileList : [];
    return /*#__PURE__*/React.createElement("div", {
      className: "tg-uploader-outer",
      style: {
        width: minimal ? undefined : "100%",
        display: "flex",
        height: "fit-content"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "tg-uploader-inner",
      style: {
        width: "100%",
        height: "fit-content",
        minWidth: 0
      }
    }, acceptToUse && /*#__PURE__*/React.createElement("div", {
      className: Classes.TEXT_MUTED,
      style: {
        fontSize: 11,
        marginBottom: 5
      }
    }, "Accepts ", acceptToUse), /*#__PURE__*/React.createElement(Dropzone, _extends({
      disabled: disabled,
      onClick: function onClick(evt) {
        return evt.preventDefault();
      },
      multiple: fileLimit !== 1,
      accept: acceptToUse,
      onDrop: function () {
        var _onDrop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(acceptedFiles, rejectedFiles) {
          var fileNames, cleanedFileList, keepGoing, responses;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (rejectedFiles.length) {
                    fileNames = rejectedFiles.map(function (f) {
                      return f.name;
                    });
                    window.toastr && window.toastr.warning("This uploader accepts " + acceptToUse + ". These files were rejected because they                 do not have the proper extension: " + fileNames.join(", "));
                  }

                  if (acceptedFiles.length) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  _this2.setState({
                    loading: true
                  });

                  if (fileLimit) {
                    acceptedFiles = acceptedFiles.slice(0, fileLimit);
                  }

                  acceptedFiles.forEach(function (file) {
                    file.loading = true;

                    if (!file.id) {
                      file.id = shortid();
                    }
                  });

                  if (!readBeforeUpload) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 9;
                  return Promise.all(acceptedFiles.map(function (file) {
                    return new Promise(function (resolve, reject) {
                      var reader = new FileReader();
                      reader.readAsText(file, "UTF-8");

                      reader.onload = function (evt) {
                        file.parsedString = evt.target.result;
                        resolve(file);
                      };

                      reader.onerror = function (err) {
                        console.error("err:", err);
                        reject(err);
                      };
                    });
                  }));

                case 9:
                  acceptedFiles = _context2.sent;

                case 10:
                  cleanedFileList = [].concat(acceptedFiles.map(function (file) {
                    return _extends({
                      originFileObj: file,
                      originalFileObj: file,
                      id: file.id,
                      lastModified: file.lastModified,
                      lastModifiedDate: file.lastModifiedDate,
                      loading: file.loading,
                      name: file.name,
                      preview: file.preview,
                      size: file.size,
                      type: file.type
                    }, file.parsedString ? {
                      parsedString: file.parsedString
                    } : {});
                  }), fileListToUse).slice(0, fileLimit ? fileLimit : undefined);
                  onChange(cleanedFileList);

                  if (!beforeUpload) {
                    _context2.next = 18;
                    break;
                  }

                  _context2.next = 15;
                  return beforeUpload(cleanedFileList, onChange);

                case 15:
                  _context2.t0 = _context2.sent;
                  _context2.next = 19;
                  break;

                case 18:
                  _context2.t0 = true;

                case 19:
                  keepGoing = _context2.t0;

                  if (keepGoing) {
                    _context2.next = 22;
                    break;
                  }

                  return _context2.abrupt("return");

                case 22:
                  if (!action) {
                    _context2.next = 32;
                    break;
                  }

                  if (!uploadInBulk) {
                    _context2.next = 26;
                    break;
                  }

                  _context2.next = 30;
                  break;

                case 26:
                  responses = [];
                  _context2.next = 29;
                  return Promise.all(acceptedFiles.map(function (fileToUpload) {
                    var data = new FormData();
                    data.append("file", fileToUpload);
                    return axiosInstance.post(action, data).then(function (res) {
                      responses.push(res.data && res.data[0]);
                      onFileSuccess(res.data[0]).then(function () {
                        cleanedFileList = cleanedFileList.map(function (file) {
                          var fileToReturn = _extends({}, file, res.data[0]);

                          if (fileToReturn.id === fileToUpload.id) {
                            fileToReturn.loading = false;
                          }

                          return fileToReturn;
                        });
                        onChange(cleanedFileList);
                      });
                    })["catch"](function (err) {
                      console.error("Error uploading file:", err);
                      responses.push(_extends({}, fileToUpload, {
                        error: err && err.msg ? err.msg : err
                      }));
                      cleanedFileList = cleanedFileList.map(function (file) {
                        var fileToReturn = _extends({}, file);

                        if (fileToReturn.id === fileToUpload.id) {
                          fileToReturn.loading = false;
                          fileToReturn.error = true;
                        }

                        return fileToReturn;
                      });
                      onChange(cleanedFileList);
                    });
                  }));

                case 29:
                  onFieldSubmit(responses);

                case 30:
                  _context2.next = 33;
                  break;

                case 32:
                  onChange(cleanedFileList.map(function (file) {
                    return _extends({}, file, {
                      loading: false
                    });
                  }));

                case 33:
                  _this2.setState({
                    loading: false
                  });

                case 34:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onDrop(_x, _x2) {
          return _onDrop.apply(this, arguments);
        }

        return onDrop;
      }()
    }, dropzoneProps), function (_ref2) {
      var getRootProps = _ref2.getRootProps,
          getInputProps = _ref2.getInputProps,
          isDragAccept = _ref2.isDragAccept,
          isDragReject = _ref2.isDragReject,
          isDragActive = _ref2.isDragActive;
      return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
        className: classnames("tg-dropzone", className, {
          "tg-dropzone-minimal": minimal,
          "tg-dropzone-active": isDragActive,
          "tg-dropzone-reject": isDragReject,
          // tnr: the acceptClassName/rejectClassName doesn't work with file extensions (only mimetypes are supported when dragging). Thus we'll just always turn the drop area blue when dragging and let the filtering occur on drop. See https://github.com/react-dropzone/react-dropzone/issues/888#issuecomment-773938074
          "tg-dropzone-accept": isDragAccept,
          "tg-dropzone-disabled": disabled
        })
      }), /*#__PURE__*/React.createElement("input", getInputProps()), contentOverride || /*#__PURE__*/React.createElement("div", {
        title: acceptToUse ? "Accepts only the following file types: " + acceptToUse : "Accepts any file input",
        className: "tg-upload-inner"
      }, innerIcon || /*#__PURE__*/React.createElement(Icon, {
        icon: "upload",
        iconSize: minimal ? 15 : 30
      }), innerText || (minimal ? "Upload" : "Click or drag to upload"))), showFilesCount ? /*#__PURE__*/React.createElement("div", {
        className: "tg-upload-file-list-counter"
      }, "Files: ", fileList ? fileList.length : 0) : null);
    }), fileList && showUploadList && !minimal && !!fileList.length && /*#__PURE__*/React.createElement("div", {
      className: overflowList ? "tg-upload-file-list-item-overflow" : null
    }, fileList.map(function (file, index) {
      var loading = file.loading,
          error = file.error,
          name = file.name,
          originalName = file.originalName,
          url = file.url,
          downloadName = file.downloadName;
      var icon;
      var isPreviewable = false;

      if (loading) {
        icon = "repeat";
      } else if (error) {
        icon = "error";
      } else {
        if (onPreviewClick) {
          isPreviewable = true;
          icon = "eye-open";
        } else {
          icon = "saved";
        }
      }

      return fileListItemRenderer ? fileListItemRenderer(file, self) : /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "tg-upload-file-list-item",
        style: {
          display: "flex",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        className: classnames({
          "tg-spin": loading,
          "tg-upload-file-list-item-preview": isPreviewable
        }),
        style: {
          marginRight: 5
        },
        icon: icon,
        onClick: function onClick() {
          if (isPreviewable) {
            onPreviewClick(file, index, fileList);
          }
        }
      }), /*#__PURE__*/React.createElement("a", _extends({
        name: name || originalName
      }, url && !onFileClick ? {
        href: url
      } : {}, {
        /* eslint-disable react/jsx-no-bind*/
        onClick: function onClick() {
          return onFileClick && onFileClick(file);
        }
        /* eslint-enable react/jsx-no-bind*/

      }, downloadName ? {
        download: downloadName
      } : {}), " ", name || originalName, " ")), !loading && /*#__PURE__*/React.createElement(Icon, {
        onClick: function onClick() {
          onRemove(file, index, fileList);
          onChange(fileList.filter(function (file, index2) {
            return index2 !== index;
          }));
        },
        iconSize: 16,
        icon: "cross",
        className: "tg-upload-file-list-item-close"
      }));
    }))), threeDotMenuItems && /*#__PURE__*/React.createElement("div", {
      className: "tg-dropzone-extra-options"
    }, /*#__PURE__*/React.createElement(Popover, {
      autoFocus: false,
      minimal: true,
      content: /*#__PURE__*/React.createElement(Menu, null, threeDotMenuItems),
      position: Position.BOTTOM_RIGHT
    }, /*#__PURE__*/React.createElement(Button, {
      minimal: true,
      icon: "more"
    }))));
  };

  return Uploader;
}(Component);

export default Uploader;